import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { APPLICATION_ID } from '../../../constants';

import Cofidis from './payment-choice/Cofidis';
import ApplePay from './payment-choice/ApplePay';
import GooglePay from './payment-choice/GooglePay';
import CreditCard from './payment-choice/CreditCard';
import CryptoLyzi from './payment-choice/CryptoLyzi';

import { PaymentSelectionContainer } from './FunnelPaymentSelectionStepStyle';

const FunnelPaymentSelectionStep = ({
    setPaymentType,
    cartTotalValue,
    googlePayAllowed,
    applePayAllowed
}) => {
    const [selectedMethod, setSelectedMethod] = useState();

    const handleMethodChange = value => {
        if (selectedMethod !== value) {
            setSelectedMethod(value);
            setPaymentType(value);
        }
    };

    return (
        <PaymentSelectionContainer>
            {APPLICATION_ID !== '147' && (
                <CreditCard
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                />
            )}

            {!['111', '147'].includes(APPLICATION_ID) && googlePayAllowed && (
                <GooglePay
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                />
            )}

            {!['111', '147'].includes(APPLICATION_ID) && applePayAllowed && (
                <ApplePay selectedMethod={selectedMethod} handleMethodChange={handleMethodChange} />
            )}

            {APPLICATION_ID === '111' && (
                <Cofidis
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                    cartTotalValue={cartTotalValue}
                />
            )}

            {APPLICATION_ID === '147' && (
                <CryptoLyzi
                    selectedMethod={selectedMethod}
                    handleMethodChange={handleMethodChange}
                />
            )}
        </PaymentSelectionContainer>
    );
};

FunnelPaymentSelectionStep.propTypes = {
    partnerId: PropTypes.number,
    cartTotalValue: PropTypes.number
};

const mapStateToProps = state => {
    return {
        googlePayAllowed:
            state.ebon.ebons.ebonPaymentConfig &&
            state.ebon.ebons.ebonPaymentConfig.googlePayAllowed,
        applePayAllowed:
            state.ebon.ebons.ebonPaymentConfig && state.ebon.ebons.ebonPaymentConfig.applePayAllowed
    };
};

export default withRouter(connect(mapStateToProps)(FunnelPaymentSelectionStep));



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/FunnelPaymentSelectionStep.js